import { render, staticRenderFns } from "./Point-list.vue?vue&type=template&id=faad844c&"
import script from "./Point-list.vue?vue&type=script&lang=js&"
export * from "./Point-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports